var map = {
	"./dinos/antipattern.png": "213d",
	"./dinos/badbitch.png": "4875",
	"./dinos/badgirl.png": "8a3e",
	"./dinos/birthday.png": "0006",
	"./dinos/british.png": "4920",
	"./dinos/broadway.png": "cb75",
	"./dinos/canadian.png": "1c6c",
	"./dinos/caveman.png": "01e5",
	"./dinos/champ.png": "c217",
	"./dinos/classical.png": "f400",
	"./dinos/clock.png": "c62a",
	"./dinos/cute.png": "d7de",
	"./dinos/dalbabob.png": "1090",
	"./dinos/dino-gamer.jpeg": "47d5",
	"./dinos/dino-send.jpeg": "dca7",
	"./dinos/dino.png": "1dc4",
	"./dinos/dino_sad.png": "ff95",
	"./dinos/engineer.png": "2405",
	"./dinos/fastforward.png": "6e68",
	"./dinos/first.png": "dd95",
	"./dinos/gaucha.png": "c83d",
	"./dinos/got.png": "ae0d",
	"./dinos/hakunamakiki.png": "4db3",
	"./dinos/indikikijones.png": "82da",
	"./dinos/kids.png": "410e",
	"./dinos/kikikiki.png": "82b1",
	"./dinos/lionking.png": "2cc5",
	"./dinos/lost.png": "e59c",
	"./dinos/mathieu.png": "284d",
	"./dinos/miraculous.png": "f318",
	"./dinos/missionimpokikible.png": "b2b8",
	"./dinos/monster.png": "590e",
	"./dinos/multifaced.png": "4c60",
	"./dinos/nick.png": "08ac",
	"./dinos/pebble.png": "7493",
	"./dinos/pixel.png": "f396",
	"./dinos/play-game.png": "939e",
	"./dinos/psycho.png": "c961",
	"./dinos/reporter.png": "3e06",
	"./dinos/rick.png": "11ec",
	"./dinos/singer.png": "bbab",
	"./dinos/stayingalive.png": "d7a8",
	"./dinos/warning.png": "56bd",
	"./games/jogo.jpg": "b722",
	"./games/make.jpg": "4db5",
	"./games/whos.jpg": "f77c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";